import { render, staticRenderFns } from "./MainSideBar.vue?vue&type=template&id=24785b81"
import script from "./MainSideBar.vue?vue&type=script&lang=js"
export * from "./MainSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports